import { OwnershipStatusIndicator } from '@internal/backstage-plugin-common-library-react';
import {
  hasRepositoryConfirmedOwner,
  hasRepositoryProposedOwner,
} from '@internal/plugin-catalog-page-addons-react';
import React from 'react';

import {
  IconLinkVerticalProps,
  InfoCardVariants,
} from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

import { AboutCard } from '../Components/AboutCard';

export const RepositoryAboutCard = (props: { variant?: InfoCardVariants }) => {
  const { entity } = useEntity();

  const ownershipStatusLink: IconLinkVerticalProps[] =
    hasRepositoryConfirmedOwner(entity) || hasRepositoryProposedOwner(entity)
      ? [
          {
            label: hasRepositoryConfirmedOwner(entity)
              ? 'Ownership confirmed'
              : 'Ownership not confirmed',
            icon: (
              <OwnershipStatusIndicator
                isConfirmed={hasRepositoryConfirmedOwner(entity)}
              />
            ),
            disabled: true,
          },
        ]
      : [];

  return (
    <AboutCard
      variant={props.variant || 'gridItem'}
      additionalSubHeaderLinks={ownershipStatusLink}
    />
  );
};
